import React, { useCallback, useEffect, useState } from 'react'
import Spinners from '../components/Spinners'

export const useFetchImages = () => {
    
    const [images, setImages] = useState( () => { return [] })
    const [IMGinput, setIMGinput] = useState( () => { return "" })
    const [numIMG, setNUMimg] = useState( () => { return 10 })
    const [loading, setLoading] = useState(() => { return true })

    const handleSubmit = (event) => {
        event.preventDefault();
        
        const textoInput = event.target[0].value; //Target es el form, .[0] es el 1er hijo que es mi input text.
        setIMGinput(textoInput);

        const NUMInput = event.target[1].value; //Target es el form, .[1] es el 2do hijo que es mi input text.
        setNUMimg(NUMInput);
        
        event.target.reset();
    }

    const peticion = useCallback( async () => {

            setLoading(true);

            const acessKey = `client_id=Us-TQ5RiACF5-vhQ-Vd6vRxCv_MA0VajbeuyY8y6ywI`;
            const route = IMGinput !== "" ? `https://api.unsplash.com/search/photos/?query=${encodeURI(IMGinput)}&per_page=${numIMG}&${acessKey}`
                                          : `https://api.unsplash.com/photos/?${acessKey}` ;
    
    
            
            const resp = await fetch(route)
            const data = await resp.json()
    
            if(data.results){ //Si existe '.results' en la respuesta, ES QUE FUE DE UNA BUSQUEDA
                setImages(data.results)
            }else{
                setImages(data) //Si no aparece, son fotos default que no tienen busqueda.
            }


            setLoading(false);
        }
    , [IMGinput, numIMG] );

    //El efecto no puede ser async, pero la Fx que le pongamos adentro SÍ!
    useEffect(() => {
        peticion();
    },[peticion]) //La peticion se ejecuta cada vez que el contenido del INPUT cambia

    const loadingYESorNO = useCallback( () => {
        if(loading === true){
            return <Spinners/>
        }
    }, [loading])


    return [images, handleSubmit, loadingYESorNO]

}
